import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { logger } from '@/utils/logger'

export function RouteLogger() {
  const location = useLocation()

  useEffect(() => {
    // Log route changes
    logger.info(`Route changed to: ${location.pathname}${location.search}`, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
      timestamp: new Date().toISOString(),
    })
  }, [location])

  return null // This component doesn't render anything
}
